export { default } from "./useTrialCampaignPost";
